<dm-empty-state [size]="size()" [pattern]="pattern()" [heading]="heading()" [description]="resolvedDescription()">
  <dm-icon [featured]="true" [theme]="iconTheme()" [color]="iconColor()" [size]="iconSize()" [name]="resolvedIcon()" />

  @switch (kind()) {
    @case ('nothing-yet') {
      <ng-content select="[slot=actions]" />
    }
    @case ('filtered') {
      <dm-button slot="actions" color="secondary" size="sm" (click)="resetRequested.emit()">{{ resetLabel() }}</dm-button>
    }
    @case ('load-failed') {
      <dm-button slot="actions" color="secondary" size="sm" (click)="retryRequested.emit()">
        <dm-icon slot="leading" name="refresh-cw-01" />
        {{ retryLabel }}
      </dm-button>
    }
    @case ('unavailable') {
      <dm-button slot="actions" color="secondary" size="sm" (click)="backRequested.emit()">{{ backLabel }}</dm-button>
    }
  }
</dm-empty-state>
